import { useContext } from 'react';

import { ReplenishBalanceModalContext } from './ReplenishBalanceModalContext';

export const useReplenishBalanceModalContext = () => useContext(ReplenishBalanceModalContext);
